export enum WriterSalesAnalyticsDetailReportEnum {
  SALES = 'SALES',
  DONATION = 'DONATION',
  VIEW = 'VIEW',
  LIKE = 'LIKE',
  SHELF_ADDED = 'SHELF_ADDED',
  SALES_BY_CHAPTER = 'SALES_BY_CHAPTER',
  SALES_BY_BOOK = 'SALES_BY_BOOK',
}
